import api from "../../api.js";

export async function fetchExpiryStock() {
  const res = await api.get("/api/expiry-stock");
  return res.data && Array.isArray(res.data.data) ? res.data.data : [];
}

export async function pullFromInventory(sku) {
  const encoded = encodeURIComponent(String(sku));
  const res = await api.post(`/api/expiry-stock/${encoded}/pull-from-inventory`);
  return res.data;
}

